export const SET_CATALOGS = 'SET_CATALOGS'